import React from 'react';
import { cloneDeep } from 'lodash';
import ObjectID from 'bson-objectid';
import { Button, Form, FormSection, FormInput } from '@praktio/common-ui';

export const CourseCategories = ({
  course,
  setCourse,
}: {
  course: ICourse;
  setCourse: React.Dispatch<React.SetStateAction<ICourse>>;
}) => {
  const categories = course.categories || [];
  const onAddCategoryClick = () => {
    const updatedCourse = cloneDeep(course);
    if (!updatedCourse.categories) {
      updatedCourse.categories = [];
    }
    updatedCourse.categories.push({ _id: new ObjectID().toHexString(), name: 'New Category' });
    setCourse(updatedCourse);
  };

  const onCategoryEdit = (value: string, id: string) => {
    const updatedCourse = cloneDeep(course);
    const category = updatedCourse.categories?.find((c) => c._id === id);
    if (category) {
      category.name = value;
      setCourse(updatedCourse);
    }
  };

  return (
    <Form formId="course-categories-form" onSubmit={() => {}} className="mt-4">
      <FormSection sectionName="Course Categories">
        <div>
          <div>
            <Button onClick={onAddCategoryClick}>Add Category</Button>
          </div>
          <div className="Course-categories mt-4">
            <div>
              {categories.map((c, i) => (
                <div key={c._id} className="Course-categories-row">
                  <FormInput
                    noLabel
                    noPlaceholder
                    value={c.name}
                    onChange={(e: any) => {
                      onCategoryEdit(e.target.value, c._id as string);
                    }}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </FormSection>
    </Form>
  );
};

export default CourseCategories;
